module.exports = __webpack_public_path__ + "img/home-07-cosmopolitan-sample-04-street-02.7f44bf7c.jpg";